import { types } from 'mobx-state-tree';

export const AcademicYearModel = types.model('AcademicYear', {
	id: types.identifierNumber,
	start_year: types.number,
	end_year: types.number,
	academic_year: types.string,
});

export const AcademicQuarterModel = types.model('AcademicQuarter', {
	id: types.identifierNumber,
	start_date: types.string,
	end_date: types.string,
});

export const SemesterModel = types.model('Semester', {
	id: types.identifierNumber,
	academic_year: types.maybeNull(AcademicYearModel),
	academic_quarters: types.array(AcademicQuarterModel),
	name: types.string,
	start_date: types.string,
	end_date: types.string,
	is_enabled: types.boolean,
});
